export default __webpack_public_path__ + "static/media/577.8f410854.png";